function VoteThankYou() {
  return (
    <main className="voting__main">
      <h2>Thanks for voting</h2>
    </main>
  );
}

export default VoteThankYou;
